/* eslint-disable */
/**
 * Hitowa permission matrix — 134 functions × 6 roles.
 *
 * Transcribed from the client's own matrix
 * (`KEiROW基幹システム_要望機能一覧.html`, tab 機能一覧). When that sheet
 * changes, this table has to be brought in line by hand.
 */

export type RoleKey = 'hqAdmin' | 'hq' | 'contractor' | 'owner' | 'staff' | 'therapist';

export type AccessLevel = 'full' | 'limited' | 'none';

/** Role labels as the source sheet words them. */
export const ROLE_LABELS: Record<RoleKey, string> = {
  hqAdmin: '本部管理者',
  hq: '本部',
  contractor: '委託先',
  owner: 'オーナー',
  staff: 'スタッフ',
  therapist: '施術家',
};

export interface FunctionAccess {
  /** Row number in the source sheet. */
  no: number;
  /** Permission key for the 大分類 this function belongs to. */
  permission: string;
  /** 大分類 */
  category: string;
  /** 中分類 */
  sub: string;
  /** 小分類 */
  detail: string;
  access: Record<RoleKey, AccessLevel>;
}

/** Permission key per 大分類, in sheet order. */
export const FUNCTION_PERMISSIONS: Record<string, string> = {
  'ログイン画面': 'FN01',
  'メイン画面': 'FN02',
  '本部情報マスタ': 'FN03',
  '基幹店マスタ': 'FN04',
  '拠点マスタ': 'FN05',
  'ユーザーマスタ': 'FN06',
  '施術家マスタ': 'FN07',
  '権限マスタ': 'FN08',
  '事業所リスト': 'FN09',
  '法人マスタ': 'FN10',
  '同一建物マスタ': 'FN11',
  '事業所ユーザーマスタ': 'FN12',
  '医療機関マスタ': 'FN13',
  '医師マスタ': 'FN14',
  '保険診療料金': 'FN15',
  '自由診療料金': 'FN16',
  '税率': 'FN17',
  '保険者マスタ': 'FN18',
  '書式マスタ': 'FN19',
  '利用者管理': 'FN20',
  'スケジュール・実績管理': 'FN21',
  'レセプト管理': 'FN22',
  '法人請求管理': 'FN23',
  '加盟店請求管理': 'FN24',
  'タックシール・封筒印刷': 'FN25',
  'インフォメーション機能': 'FN26',
  '売上管理': 'FN27',
  '一覧インポート/エクスポート機能': 'FN28',
};

export const FUNCTION_ACCESS: FunctionAccess[] = [
  {
    no: 1,
    permission: 'FN01',
    category: 'ログイン画面',
    sub: '',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 2,
    permission: 'FN02',
    category: 'メイン画面',
    sub: '',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 3,
    permission: 'FN03',
    category: '本部情報マスタ',
    sub: '基本情報登録機能',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 4,
    permission: 'FN04',
    category: '基幹店マスタ',
    sub: '変更履歴の表示',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 5,
    permission: 'FN04',
    category: '基幹店マスタ',
    sub: '関連マスタの紐づけ機能',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 6,
    permission: 'FN05',
    category: '拠点マスタ',
    sub: '拠点一覧',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 7,
    permission: 'FN05',
    category: '拠点マスタ',
    sub: '基本情報登録機能',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 8,
    permission: 'FN05',
    category: '拠点マスタ',
    sub: '変更履歴の表示',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 9,
    permission: 'FN06',
    category: 'ユーザーマスタ',
    sub: 'ユーザー一覧',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 10,
    permission: 'FN06',
    category: 'ユーザーマスタ',
    sub: '基本情報登録機能',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 11,
    permission: 'FN06',
    category: 'ユーザーマスタ',
    sub: '変更履歴の表示',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 12,
    permission: 'FN07',
    category: '施術家マスタ',
    sub: '施術家一覧',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 13,
    permission: 'FN07',
    category: '施術家マスタ',
    sub: '基本情報登録機能',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 14,
    permission: 'FN07',
    category: '施術家マスタ',
    sub: '変更履歴の表示',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 15,
    permission: 'FN08',
    category: '権限マスタ',
    sub: '権限一覧',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 16,
    permission: 'FN08',
    category: '権限マスタ',
    sub: '基本情報登録機能',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 17,
    permission: 'FN09',
    category: '事業所リスト',
    sub: '事業所一覧',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 18,
    permission: 'FN09',
    category: '事業所リスト',
    sub: '基本情報登録機能',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 19,
    permission: 'FN10',
    category: '法人マスタ',
    sub: '法人一覧',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 20,
    permission: 'FN10',
    category: '法人マスタ',
    sub: '基本情報登録機能',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 21,
    permission: 'FN11',
    category: '同一建物マスタ',
    sub: '同一建物一覧',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 22,
    permission: 'FN11',
    category: '同一建物マスタ',
    sub: '基本情報登録機能',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 23,
    permission: 'FN12',
    category: '事業所ユーザーマスタ',
    sub: '事業所一覧',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 24,
    permission: 'FN12',
    category: '事業所ユーザーマスタ',
    sub: '事業所ユーザーの登録',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 25,
    permission: 'FN13',
    category: '医療機関マスタ',
    sub: '医療機関一覧',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 26,
    permission: 'FN13',
    category: '医療機関マスタ',
    sub: '基本情報登録機能',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 27,
    permission: 'FN13',
    category: '医療機関マスタ',
    sub: '変更履歴の表示',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 28,
    permission: 'FN14',
    category: '医師マスタ',
    sub: '医師一覧',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 29,
    permission: 'FN14',
    category: '医師マスタ',
    sub: '基本情報登録機能',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 30,
    permission: 'FN15',
    category: '保険診療料金',
    sub: '保険診療料金一覧',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 31,
    permission: 'FN15',
    category: '保険診療料金',
    sub: '基本情報登録機能',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 32,
    permission: 'FN15',
    category: '保険診療料金',
    sub: '変更履歴の表示',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 33,
    permission: 'FN16',
    category: '自由診療料金',
    sub: '自由診療料金一覧',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 34,
    permission: 'FN16',
    category: '自由診療料金',
    sub: '基本情報登録機能',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 35,
    permission: 'FN16',
    category: '自由診療料金',
    sub: '変更履歴の表示',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 36,
    permission: 'FN17',
    category: '税率',
    sub: '税率登録',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 37,
    permission: 'FN17',
    category: '税率',
    sub: '税率履歴',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 38,
    permission: 'FN18',
    category: '保険者マスタ',
    sub: '保険者一覧',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 39,
    permission: 'FN18',
    category: '保険者マスタ',
    sub: '保険者情報変更履歴',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 40,
    permission: 'FN18',
    category: '保険者マスタ',
    sub: '基本情報登録機能',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 41,
    permission: 'FN19',
    category: '書式マスタ',
    sub: '書式一覧',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 42,
    permission: 'FN19',
    category: '書式マスタ',
    sub: '書式変更履歴',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 43,
    permission: 'FN20',
    category: '利用者管理',
    sub: '利用者',
    detail: '一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 44,
    permission: 'FN20',
    category: '利用者管理',
    sub: '利用者',
    detail: '変更履歴一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 45,
    permission: 'FN20',
    category: '利用者管理',
    sub: '利用者',
    detail: '閲覧・登録',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 46,
    permission: 'FN20',
    category: '利用者管理',
    sub: '問診票',
    detail: '閲覧・登録',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 47,
    permission: 'FN20',
    category: '利用者管理',
    sub: '問診票',
    detail: '変更履歴一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 48,
    permission: 'FN20',
    category: '利用者管理',
    sub: '施術場所',
    detail: '住所・緯度経度',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 49,
    permission: 'FN20',
    category: '利用者管理',
    sub: '施術場所',
    detail: '同一建物',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 50,
    permission: 'FN20',
    category: '利用者管理',
    sub: '保険証情報',
    detail: '閲覧・登録',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 51,
    permission: 'FN20',
    category: '利用者管理',
    sub: '保険証情報',
    detail: '変更履歴一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 52,
    permission: 'FN20',
    category: '利用者管理',
    sub: '医療助成公費情報登録',
    detail: '閲覧・登録',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 53,
    permission: 'FN20',
    category: '利用者管理',
    sub: '医療助成公費情報登録',
    detail: '変更履歴一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 54,
    permission: 'FN20',
    category: '利用者管理',
    sub: '同意書履歴(マッサージ)',
    detail: '閲覧・登録',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 55,
    permission: 'FN20',
    category: '利用者管理',
    sub: '同意書履歴(マッサージ)',
    detail: '変更履歴一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 56,
    permission: 'FN20',
    category: '利用者管理',
    sub: '同意書履歴(鍼灸)',
    detail: '閲覧・登録',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 57,
    permission: 'FN20',
    category: '利用者管理',
    sub: '同意書履歴(鍼灸)',
    detail: '変更履歴一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 58,
    permission: 'FN20',
    category: '利用者管理',
    sub: '転帰登録',
    detail: '閲覧・登録',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 59,
    permission: 'FN20',
    category: '利用者管理',
    sub: '転帰登録',
    detail: '変更履歴一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 60,
    permission: 'FN20',
    category: '利用者管理',
    sub: '基本スケジュール',
    detail: '閲覧・登録',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 61,
    permission: 'FN20',
    category: '利用者管理',
    sub: '基本スケジュール',
    detail: '施術別スケジュールコピー機能',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 62,
    permission: 'FN21',
    category: 'スケジュール・実績管理',
    sub: '施術別スケジュール・実績',
    detail: 'スケジュール画面',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 63,
    permission: 'FN21',
    category: 'スケジュール・実績管理',
    sub: '施術別スケジュール・実績',
    detail: '閲覧・登録',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 64,
    permission: 'FN21',
    category: 'スケジュール・実績管理',
    sub: '施術別スケジュール・実績',
    detail: '施術人数、売上合計',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 65,
    permission: 'FN21',
    category: 'スケジュール・実績管理',
    sub: '施術別スケジュール・実績',
    detail: '実績変更管理',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 66,
    permission: 'FN21',
    category: 'スケジュール・実績管理',
    sub: '利用者別スケジュール・実績',
    detail: '閲覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 67,
    permission: 'FN21',
    category: 'スケジュール・実績管理',
    sub: '利用者別スケジュール・実績',
    detail: '実績変更管理',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 68,
    permission: 'FN21',
    category: 'スケジュール・実績管理',
    sub: '実績差異管理',
    detail: '実績差異一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 69,
    permission: 'FN20',
    category: '利用者管理',
    sub: 'レセプト対応情報（連絡先）',
    detail: '閲覧・登録',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 70,
    permission: 'FN20',
    category: '利用者管理',
    sub: 'レセプト対応情報（連絡先）',
    detail: '変更履歴一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 71,
    permission: 'FN20',
    category: '利用者管理',
    sub: '償還払い用口座登録',
    detail: '閲覧・登録',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 72,
    permission: 'FN20',
    category: '利用者管理',
    sub: '口座振替登録',
    detail: '閲覧・登録',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 73,
    permission: 'FN20',
    category: '利用者管理',
    sub: '施術報告書',
    detail: '閲覧・登録',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 74,
    permission: 'FN20',
    category: '利用者管理',
    sub: '施術報告書',
    detail: '算定できない条件を設定',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 75,
    permission: 'FN20',
    category: '利用者管理',
    sub: '施術報告書',
    detail: '施術報告書一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 76,
    permission: 'FN20',
    category: '利用者管理',
    sub: '施術報告書',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 77,
    permission: 'FN20',
    category: '利用者管理',
    sub: '施術継続理由・状態記入書',
    detail: '閲覧・登録',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 78,
    permission: 'FN20',
    category: '利用者管理',
    sub: '施術継続理由・状態記入書',
    detail: '作成条件を設定する',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 79,
    permission: 'FN20',
    category: '利用者管理',
    sub: '施術継続理由・状態記入書',
    detail: '変更履歴一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 80,
    permission: 'FN20',
    category: '利用者管理',
    sub: '長期頻回計画書',
    detail: '閲覧・登録',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 81,
    permission: 'FN20',
    category: '利用者管理',
    sub: '長期頻回計画書',
    detail: '変更履歴一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 82,
    permission: 'FN20',
    category: '利用者管理',
    sub: '施術録',
    detail: '自動作成',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 83,
    permission: 'FN20',
    category: '利用者管理',
    sub: '同意書管理',
    detail: '同意書一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 84,
    permission: 'FN20',
    category: '利用者管理',
    sub: '同意書管理',
    detail: '同意書セット印刷',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 85,
    permission: 'FN20',
    category: '利用者管理',
    sub: '同意書管理',
    detail: '同意書ステータスを更新する',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 86,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: 'レセプトステータス権限管理',
    detail: '権限一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 87,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: 'レセプトステータス権限管理',
    detail: '権限閲覧・登録',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 88,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: 'セット印刷',
    detail: 'レセプト一覧（利用者一覧）',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 89,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: 'セット印刷',
    detail: 'レセプトステータスを更新する',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 90,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: 'セット印刷',
    detail: 'セット印刷',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 91,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: 'セット印刷',
    detail: '送付状印刷',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'full', staff: 'full', therapist: 'limited' },
  },
  {
    no: 92,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: 'レセプト管理',
    detail: 'レセプト出力対象利用者一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'limited', staff: 'limited', therapist: 'none' },
  },
  {
    no: 93,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: 'レセプト管理',
    detail: 'レセプトステータスを更新する',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'limited', staff: 'limited', therapist: 'none' },
  },
  {
    no: 94,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: 'レセプト管理',
    detail: '返送用送付状印刷',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'limited', staff: 'limited', therapist: 'none' },
  },
  {
    no: 95,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: '総括表管理',
    detail: '総括表印刷',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'limited', staff: 'limited', therapist: 'none' },
  },
  {
    no: 96,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: '総括表管理',
    detail: '総括表設定機能',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'limited', staff: 'limited', therapist: 'none' },
  },
  {
    no: 97,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: '保険入金管理',
    detail: '保険者別レセプト一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'limited', staff: 'limited', therapist: 'none' },
  },
  {
    no: 98,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: '保険入金管理',
    detail: '保険者別合計',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'limited', staff: 'limited', therapist: 'none' },
  },
  {
    no: 99,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: '保険入金管理',
    detail: '利用者別レセプト一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'limited', staff: 'limited', therapist: 'none' },
  },
  {
    no: 100,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: '保険入金管理',
    detail: '利用者別合計',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'limited', staff: 'limited', therapist: 'none' },
  },
  {
    no: 101,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: '保険入金管理',
    detail: '拠点別レセプト一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'limited', staff: 'limited', therapist: 'none' },
  },
  {
    no: 102,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: '保険入金管理',
    detail: '拠点別合計',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'limited', staff: 'limited', therapist: 'none' },
  },
  {
    no: 103,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: '保険入金管理',
    detail: 'レセプトステータスを更新する',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'limited', staff: 'limited', therapist: 'none' },
  },
  {
    no: 104,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: '保険入金管理',
    detail: '入金差異一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'limited', staff: 'limited', therapist: 'none' },
  },
  {
    no: 105,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: '保険入金管理',
    detail: '入金差異詳細管理',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'limited', staff: 'limited', therapist: 'none' },
  },
  {
    no: 106,
    permission: 'FN22',
    category: 'レセプト管理',
    sub: '保険入金管理',
    detail: '実績一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'limited', staff: 'limited', therapist: 'none' },
  },
  {
    no: 107,
    permission: 'FN23',
    category: '法人請求管理',
    sub: '実績管理',
    detail: '実績一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 108,
    permission: 'FN23',
    category: '法人請求管理',
    sub: '実績管理',
    detail: '実績変更一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 109,
    permission: 'FN23',
    category: '法人請求管理',
    sub: '請求書発行機能',
    detail: '請求書一括出力機能',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 110,
    permission: 'FN23',
    category: '法人請求管理',
    sub: '請求書発行機能',
    detail: '一括格納機能',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 111,
    permission: 'FN23',
    category: '法人請求管理',
    sub: '請求書/領収書個別発行機能',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 112,
    permission: 'FN23',
    category: '法人請求管理',
    sub: '請求書/領収書個別発行機能',
    detail: '請求書/領収書個別設定',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 113,
    permission: 'FN23',
    category: '法人請求管理',
    sub: 'クラウドサイン連携',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 114,
    permission: 'FN23',
    category: '法人請求管理',
    sub: 'クラウドサイン連携',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 115,
    permission: 'FN24',
    category: '加盟店請求管理',
    sub: '請求書発行機能',
    detail: '請求書一括出力機能',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 116,
    permission: 'FN24',
    category: '加盟店請求管理',
    sub: '資材発注サイト連携',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 117,
    permission: 'FN24',
    category: '加盟店請求管理',
    sub: '請求データ',
    detail: 'インポート',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 118,
    permission: 'FN24',
    category: '加盟店請求管理',
    sub: '分割弁済',
    detail: '閲覧・登録',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 119,
    permission: 'FN24',
    category: '加盟店請求管理',
    sub: '分割弁済',
    detail: '分割弁済一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 120,
    permission: 'FN24',
    category: '加盟店請求管理',
    sub: '請求科目マスタ',
    detail: '閲覧・登録',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 121,
    permission: 'FN24',
    category: '加盟店請求管理',
    sub: '請求科目マスタ',
    detail: '請求科目一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 122,
    permission: 'FN25',
    category: 'タックシール・封筒印刷',
    sub: '',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'full', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 123,
    permission: 'FN26',
    category: 'インフォメーション機能',
    sub: '',
    detail: '閲覧・登録',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 124,
    permission: 'FN26',
    category: 'インフォメーション機能',
    sub: '',
    detail: 'インフォメーション一覧',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'limited', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
  {
    no: 125,
    permission: 'FN27',
    category: '売上管理',
    sub: '売上推移',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 126,
    permission: 'FN27',
    category: '売上管理',
    sub: '拠点別保険区分別売上',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 127,
    permission: 'FN27',
    category: '売上管理',
    sub: '施術家別売上推移',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 128,
    permission: 'FN27',
    category: '売上管理',
    sub: '法人別売上',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 129,
    permission: 'FN27',
    category: '売上管理',
    sub: '法人施設別売上',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'full', staff: 'full', therapist: 'full' },
  },
  {
    no: 130,
    permission: 'FN27',
    category: '売上管理',
    sub: '法人施設別売上推移',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 131,
    permission: 'FN27',
    category: '売上管理',
    sub: '拠点別売上推移',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'limited', staff: 'limited', therapist: 'none' },
  },
  {
    no: 132,
    permission: 'FN27',
    category: '売上管理',
    sub: '他システムへ実績連携',
    detail: 'ハピノワ',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 133,
    permission: 'FN27',
    category: '売上管理',
    sub: '他システムへ実績連携',
    detail: 'My HITOWAサービス',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'none', staff: 'none', therapist: 'none' },
  },
  {
    no: 134,
    permission: 'FN28',
    category: '一覧インポート/エクスポート機能',
    sub: '',
    detail: '',
    access: { hqAdmin: 'full', hq: 'full', contractor: 'none', owner: 'limited', staff: 'limited', therapist: 'limited' },
  },
];
